import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "cart-container"
}
const _hoisted_2 = { class: "cart-container-products" }
const _hoisted_3 = { class: "merch-title" }
const _hoisted_4 = { class: "merch-title" }
const _hoisted_5 = { class: "cart-actions" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Continua a visitare il sito")
const _hoisted_7 = { class: "cart-container-total" }
const _hoisted_8 = { class: "cart-container-sticky" }
const _hoisted_9 = { class: "cart-total" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "cart-total-title" }, "Totale Carrello", -1)
const _hoisted_11 = {
  key: 0,
  class: "cart-total-price cart-total-price-line-through"
}
const _hoisted_12 = {
  key: 1,
  class: "cart-total-price"
}
const _hoisted_13 = {
  key: 2,
  class: "cart-total-price"
}
const _hoisted_14 = {
  class: "cart-total-code",
  for: "discount_code"
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Codice sconto")
const _hoisted_16 = { class: "cart-continue" }
const _hoisted_17 = {
  key: 1,
  class: "cart-empty-container"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "Il tuo carrello è vuoto", -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Continua a visitare il sito")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CartViewProduct = _resolveComponent("CartViewProduct")!
  const _component_CartViewExperience = _resolveComponent("CartViewExperience")!
  const _component_router_link = _resolveComponent("router-link")!

  return ($setup.products.length>0 || $setup.experiences.length>0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          ($setup.products.length>0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('common.merch')), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.products, (p) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: p.id,
                    class: "cart-product"
                  }, [
                    _createVNode(_component_CartViewProduct, {
                      product: p,
                      canRemove: true
                    }, null, 8, ["product"])
                  ]))
                }), 128))
              ], 64))
            : _createCommentVNode("", true),
          ($setup.experiences.length>0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('common.experiences')), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.experiences, (e) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: e.id,
                    class: "cart-product"
                  }, [
                    _createVNode(_component_CartViewExperience, {
                      product: e,
                      canRemove: true
                    }, null, 8, ["product"])
                  ]))
                }), 128))
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: "/merch",
              class: "btn btn-pc btn-pc-secondary"
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              ($setup.isDiscounted)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString($setup.total), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString($setup.total), 1)),
              ($setup.isDiscounted)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString($setup.discountedTotal), 1))
                : _createCommentVNode("", true),
              _createElementVNode("label", _hoisted_14, [
                _hoisted_15,
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  type: "text",
                  id: "discount_code",
                  name: "discount_code",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.discountCode) = $event)),
                  onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.getDiscountCode && $setup.getDiscountCode(...args)))
                }, null, 544), [
                  [_vModelText, $setup.discountCode]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("button", {
                class: "btn btn-pc btn-pc-primary",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.next && $setup.next(...args))),
                onKeydown: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.next && $setup.next(...args)))
              }, "Continua", 32)
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_17, [
        _hoisted_18,
        _createVNode(_component_router_link, {
          to: "/merch",
          class: "btn btn-pc btn-pc-secondary"
        }, {
          default: _withCtx(() => [
            _hoisted_19
          ]),
          _: 1
        })
      ]))
}